// contexts/UserContext.tsx
import { createContext, useContext, useState, useEffect } from "react";
import { setupAPIclient } from '../../services/setupAPIclient';
import LocalStorage from "../../helpers/localstorage";

type Feature = {
  id: number;
  key: string;
  key_plan: string;
  plan: string;
};

type CartaoCredit = {
  numero: string;
  validade: string;
  cvv: string;
};

type User = {
  address: string;
  cartao_credit: CartaoCredit | null;
  city: string;
  cnpj: string;
  cod_pix: string;
  cpf: string;
  due_date: number | string;   // pode vir como "5" ou -5
  email: string;
  features: Feature[];
  imagecompany_logo: string;
  locality: string;
  name: string;
  neighborhood: string;
  number_phone: string;
  payment_date: string;
  postal_code: string;
  sales_flow: string;
  state: string;
  type_business: string;
  uf: string;
};

type UserContextType = {
  user: User | null;
  loading: boolean;
};

const UserContext = createContext<UserContextType>({
  user: null,
  loading: true,
});

export function useUser() {
  return useContext(UserContext);
}

export function UserProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  let localStorage = new LocalStorage();

  useEffect(() => {
    async function fetchUser() {
      try {
        const token = String(localStorage.getAuthToken());
        const ApiClient = setupAPIclient(token);
        const response = await ApiClient.post(`/auth/get/login`);

        // Se precisar converter cartao_credit para objeto
        const cartaoObj = response.data.cartao_credit == null ? null : JSON.parse(response.data.cartao_credit.cartao_credit);
        const userData: User = {
          ...response.data,
          cartao_credit: cartaoObj || null,
        };
        setUser(userData);
      } catch (error) {
        console.error("Erro ao buscar dados do usuário:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchUser();
  }, []);

  return (
    <UserContext.Provider value={{ user, loading }}>
      {children}
    </UserContext.Provider>
  );
}
